import React from 'react'

const Bachpanshala = () => {
  return (
    <div>Bachpanshala123</div>
  )
}

export default Bachpanshala;